<template>
    <div>
        <h3>
            Contacts
            <v-btn :disabled="isLoading"
                   @click="showContactAddEditDialog = true"
                   class="text-none ml-2"
                   color="secondary darken-1"
                   fab
                   x-small>
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </h3>
        <v-card :key="contact.id"
                class="mt-5"
                no-gutters
                v-for="contact in contacts">
            <v-card-text style="white-space: pre-wrap;">
                <strong>
                    {{ contact.name + " " + contact.surname }}
                    <span v-if="contact.designation">
            - {{ getDesignationDescription(contact.designation) }}
          </span>
                </strong>
                <v-card-text style="white-space: pre-wrap;">
                    <v-row>
                        Email: {{ contact.email }}
                    </v-row>
                    <v-row class="mt-5">
                        Number: {{ contact.number }}
                    </v-row>

                </v-card-text>
            </v-card-text>

            <v-card-actions>
                <v-btn :disabled="isLoading || contactDeleting"
                       :loading="contactDeleting"
                       class="text-none"
                       color="secondary darken-1"
                       text
                       @click="deleteContact(contact)">
                    Delete
                </v-btn>
                <v-spacer/>
                <v-btn class="text-none"
                       color="secondary darken-1"
                       text
                       @click="editContact(contact)">
                    Edit
                </v-btn>
            </v-card-actions>
        </v-card>
        <BrokerFirmContactAddEditDialog :broker-firm-id="brokerFirmId"
                                        :show="showContactAddEditDialog"
                                        :contact="contactToEdit"
                                        @close="showContactAddEditDialog=false"
                                        @contact-added="contactAdded"
                                        @contact-updated="contactUpdated"/>
    </div>
</template>

<script>
import brokerFirmService from "@/services/brokerfirm.service";
import BrokerFirmContactAddEditDialog from "@/components/widgets/BrokerFirmContacts/BrokerFirmContactAddEditDialog.vue";

export default {
    name: "BrokerFirmContactsList",
    components: {BrokerFirmContactAddEditDialog},
    props: ["brokerFirmId"],
    data() {
        return {
            isLoading: false,
            showContactAddEditDialog: false,
            contacts: null,
            contactDeleting: false,
            brokerFirmContactDesignations: [],
            contactToEdit: null,
        }
    },
    methods: {
        async loadContacts() {
            this.contacts = await brokerFirmService.getContacts(this.brokerFirmId);
        },
        async loadBrokerFirmContactDesignations() {
            this.brokerFirmContactDesignations = await brokerFirmService.getBrokerFirmContactDesignations();
        },
        editContact(contact) {
            this.contactToEdit = contact;
            this.showContactAddEditDialog = true;
        },
        contactAdded() {
            this.loadContacts();
            this.showContactAddEditDialog = false;
        },
        contactUpdated() {
            this.loadContacts();
            this.showContactAddEditDialog = false;
        },
        getDesignationDescription(key) {
            let designation = this.brokerFirmContactDesignations.find(d => d.key === key);
            if (designation) {
                return designation.value;
            }
            return '';
        },
        async deleteContact(contact){
            const isConfirmed = confirm(
                "Are you sure you want to delete this contact?"
            );
            if (isConfirmed) {
                this.isLoading = true;
                this.isDeleting = true;
               await brokerFirmService.deleteBrokerFirmContact(contact.id);
            }
            this.isLoading = false;
            this.loadContacts();
        },
    },
    created() {
        this.loadBrokerFirmContactDesignations();
        this.loadContacts();
    },
}
</script>

<style scoped>

</style>
